import React from 'react';

import FlexModal from '../../UI/FlexModal/FlexModal';

import classes from './StudentResponsePopup.module.css';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import CircularProgressBar from '../../UI/CircularProgressBar/CircularProgressBar';
import { IsListEmpty, IsStringEmpty } from '../../../utilities/CommonMethods';
import ResourceAPIController from '../../../webServices/ResourceAPIController';
import ShowLoader from '../../../hoc/ShowLoader/ShowLoader';

class StudentResponsePopup extends React.Component {

    state = {
        subtopicsList: [],
        clearedDoubts: 'yes',
        sessionRating: { value: 0, label: [0, 10] },
        dailyFeedbackDetails: {
            studentName: '',
            submissionDate: '',
            topicName: ''
        },

        weeklyResponse: {
            studentName: '',
            submissionDate: '',
            weekName: '',
            responsesList: []
        },
        edyodaRating: { value: 0, label: [0, 10] },
        mostLiked: '',
        showPopupLoader: true,
        feedbackType: "daily",
        newDailyFeedbackResponse: []
    }

    getStudentDailyFeedbackResponse = () => {
        ResourceAPIController.getStudentDailyFeedbackResponse(this.props.topicId, this.props.userId)
            .then(response => {

                // console.log('getStudentDailyFeedbackResponse Data => ', response.result);

                this.setState({
                    showPopupLoader: false,
                    isOldFeedback: response.result.isOldFeedback,
                    subtopicsList: response.result.subtopicsList,
                    clearedDoubts: response.result.clearedDoubts[0],
                    sessionRating: response.result.sessionRating,
                    dailyFeedbackDetails: response.result.feedbackData,
                    feedbackType: response.result.feedbackType,
                    newDailyFeedbackResponse: response.result.newDailyFeedbackResponse
                });

            })
            .catch(err => {
                console.log('getStudentDailyFeedbackResponse error => ', err)
                this.setState({ showPopupLoader: false });
            });
    }

    getStudentWeeklyFeedbackResponse = () => {
        ResourceAPIController.getStudentWeeklyFeedbackResponse(this.props.feedbackId, this.props.userId)
            .then(response => {

                this.setState({
                    showPopupLoader: false,
                    weeklyResponse: response.result.weeklyResponse,
                    edyodaRating: response.result.edyodaRating,
                    mostLiked: response.result.mostLiked
                });

            })
            .catch(err => {
                console.log('getStudentWeeklyFeedbackResponse error => ', err)
                this.setState({ showPopupLoader: false });
            });
    }

    componentDidMount() {
        if (this.props.forWeekly) {
            this.getStudentWeeklyFeedbackResponse();
        } else {
            this.getStudentDailyFeedbackResponse();
        }
    }

    render() {

        const subtopicsResponses = !IsListEmpty(this.state.subtopicsList)
            ? this.state.subtopicsList.map((subtopic, index) => {
                return (
                    <div className={classes.SubtopicItem} key={index}>
                        <p className={classes.Title}>{subtopic.title}</p>
                        <p className={[classes.Response, subtopic.response.toLocaleLowerCase() === 'yes' ? classes.Green : classes.Red].join(' ')}>{subtopic.response}</p>
                    </div>
                );
            }) : <p>Subtopics are not available.</p>;

        const weeklyFeedbackResponses = !IsListEmpty(this.state.weeklyResponse.responsesList)
            ? this.state.weeklyResponse.responsesList.map((response, index) => {
                return (
                    <div className={classes.SubtopicItem} key={index}>
                        <p className={[classes.Title, classes.AlignLeft].join(' ')}>{response.title}</p>
                        <p className={[classes.Response, classes.WeeklyResponse,
                        response.value.toLocaleLowerCase() === 'strongly agree' ||
                            response.value.toLocaleLowerCase() === 'agree'
                            ? classes.Green : response.value.toLocaleLowerCase() === 'disagree'
                                ? classes.Red : classes.Gray].join(' ')}>
                            {response.value}
                        </p>
                    </div>
                );
            }) : <p>Response not available.</p>;

        const newDailyFeedbackResponse = !IsListEmpty(this.state.newDailyFeedbackResponse)
            ? this.state.newDailyFeedbackResponse.map((question, index) => {
                if (index === 0) {
                    return (
                        <div className={classes.QuestionDiv} key={index}>
                            <p className={[classes.Title, classes.QuestionTitle].join(' ')}>{index + 1 + '. ' + question.title}</p>
                            <div className={classes.Stars} style={{ "--rating": (question.value) }}> </div>
                        </div>
                    );
                } else if (index === 1) {
                    return (
                        <div className={classes.QuestionDiv} key={index}>
                            <p className={[classes.Title, classes.QuestionTitle].join(' ')}>{index + 1 + '. ' + question.title}</p>
                            {question.value[0] == 0
                                ? <p className={[classes.Response, classes.QuestionResponse, classes.Boring].join(' ')}>
                                    BORING
                                </p>
                                : <p className={[classes.Response, classes.QuestionResponse, classes.Engaging].join(' ')}>
                                    ENGAGING
                                </p>
                            }

                        </div>
                    );
                } else if (index === 2) {
                    return (
                        <div className={classes.QuestionDiv} key={index}>
                            <p className={[classes.Title, classes.QuestionTitle].join(' ')}>{index + 1 + '. ' + question.title}</p>
                            <p className={[classes.Response, classes.QuestionResponse].join(' ')}>
                                {
                                    question.value.map(item => {
                                        if (!IsStringEmpty(item)) {
                                            return <span className={classes.ImprovementItem}>
                                                {item === 'nothing' ? 'EVERYTHING IS GREAT'
                                                    : item.replaceAll('_', ' ')}
                                            </span>
                                        }
                                    })
                                }
                            </p>
                        </div>
                    );
                } else if (index === 3) {
                    return (
                        <div className={classes.QuestionDiv} key={index}>
                            <p className={[classes.Title, classes.QuestionTitle].join(' ')}>{index + 1 + '. ' + question.title}</p>
                            <p className={[classes.Response, classes.QuestionResponse, classes.Comment].join(' ')}>
                                {question.value}
                            </p>
                        </div>
                    );
                } else {
                    return <p>Data Not Available</p>
                }
            }) : <p>Response not available.</p>;

        return (
            <FlexModal visible={this.props.show} width="45%">
                {this.props.forWeekly
                    ? <div className={classes.StudentResponsePopup}>
                        <img
                            className={classes.CloseIcon}
                            src={closeIconBlack}
                            alt="Close Icon"
                            onClick={this.props.closePopup}
                        />
                        {

                            this.state.showPopupLoader
                                ? <div className={classes.LoaderContainer}>
                                    <ShowLoader isLoading={true} transparentBg={true} />
                                </div>
                                : <>
                                    <p className={classes.DateTime}>{this.state.weeklyResponse.submissionDate}</p>
                                    <h4 className={classes.StudentName}>{this.state.weeklyResponse.studentName}’s Feedback</h4>

                                    <div className={classes.WeeklyResponseContainer}>
                                        <div className={[classes.TopicContainer, classes.FullWidth].join(' ')}>
                                            <h5 className={classes.TopicName}>{this.props.weekName}</h5>
                                            <div className={classes.QuestionsContainer}>
                                                {weeklyFeedbackResponses}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={classes.RecommendDiv}>
                                        <div>
                                            <p className={[classes.Title, classes.AlignLeft].join(' ')}> What did you like the MOST abbout this Program?</p>
                                            <p className={[classes.Response, classes.WeeklyResponse, classes.Blue].join(' ')}>
                                                {this.state.mostLiked}
                                            </p>
                                        </div>
                                        <div className={[classes.CircularProgressBarDiv, classes.Rating].join(' ')}>
                                            <CircularProgressBar
                                                styleclass={this.state.edyodaRating.value >= 80 ? "Green" : this.state.edyodaRating.value >= 70 ? "Yellow" : "Red"}
                                                type="fraction"
                                                progress={this.state.edyodaRating.value}
                                                value={this.state.edyodaRating.label}
                                                showProgressText={true}
                                                progressText={'SESSION RATING'}
                                            />
                                        </div>
                                    </div>
                                </>
                        }
                    </div>
                    : <div className={classes.StudentResponsePopup}>
                        <img
                            className={classes.CloseIcon}
                            src={closeIconBlack}
                            alt="Close Icon"
                            onClick={this.props.closePopup}
                        />
                        {
                            this.state.showPopupLoader
                                ? <div className={classes.LoaderContainer}>
                                    <ShowLoader isLoading={true} transparentBg={true} />
                                </div>
                                : <>
                                    <p className={classes.DateTime}>{this.state.dailyFeedbackDetails.submissionDate}</p>
                                    <h4 className={classes.StudentName}>{this.state.dailyFeedbackDetails.studentName}’s Feedback</h4>

                                    {
                                        this.state.isOldFeedback
                                            ? <div className={[classes.ResponseContainer, classes.OldFeedbackContainer].join(' ')}>
                                                <div className={classes.TopicContainer}>
                                                    <h5 className={classes.TopicName}>{this.state.dailyFeedbackDetails.topicName}</h5>
                                                </div>
                                                <div className={[classes.CircularProgressBarDiv, classes.AlignHorizontal].join(' ')}>
                                                    <CircularProgressBar
                                                        styleclass={this.state.clearedDoubts.toLocaleLowerCase() === 'yes' ? "Green" : "Red"}
                                                        type="text"
                                                        progress={100}
                                                        value={this.state.clearedDoubts.toUpperCase()}
                                                        showProgressText={true}
                                                        progressText={'CLEARED THEIR DOUBTS'}
                                                    />

                                                    <CircularProgressBar
                                                        styleclass={this.state.sessionRating.value >= 80 ? "Green" : this.state.sessionRating.value >= 70 ? "Yellow" : "Red"}
                                                        type="fraction"
                                                        progress={this.state.sessionRating.value}
                                                        value={this.state.sessionRating.label}
                                                        showProgressText={true}
                                                        progressText={'SESSION RATING'}
                                                    />
                                                </div>
                                            </div>
                                            : this.state.feedbackType === "daily"
                                                ? <div className={classes.ResponseContainer}>
                                                    <div className={classes.TopicContainer}>
                                                        <h5 className={classes.TopicName}>{this.state.dailyFeedbackDetails.topicName}</h5>
                                                        <div className={classes.SubTopicsContainerDiv}>
                                                            <p className={classes.DescriptionText}>SUB-TOPICS UNDERSTOOD BY STUDENTS</p>
                                                            <div className={classes.SubTopicsContainer}>
                                                                {subtopicsResponses}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={classes.CircularProgressBarDiv}>
                                                        <CircularProgressBar
                                                            styleclass={this.state.clearedDoubts.toLocaleLowerCase() === 'yes' ? "Green" : "Red"}
                                                            type="text"
                                                            progress={100}
                                                            value={this.state.clearedDoubts.toUpperCase()}
                                                            showProgressText={true}
                                                            progressText={'CLEARED THEIR DOUBTS'}
                                                        />

                                                        <CircularProgressBar
                                                            styleclass={this.state.sessionRating.value >= 80 ? "Green" : this.state.sessionRating.value >= 70 ? "Yellow" : "Red"}
                                                            type="fraction"
                                                            progress={this.state.sessionRating.value}
                                                            value={this.state.sessionRating.label}
                                                            showProgressText={true}
                                                            progressText={'SESSION RATING'}
                                                        />
                                                    </div>
                                                </div>
                                                : <div className={classes.ResponseContainer}>
                                                    <div className={[classes.TopicContainer, classes.FullWidth, classes.RemovePadding].join(' ')}>
                                                        <h5 className={classes.TopicName}>
                                                            {this.state.dailyFeedbackDetails.topicName}
                                                        </h5>
                                                        <div className={classes.SubTopicsContainer}>
                                                            {newDailyFeedbackResponse}
                                                        </div>
                                                    </div>
                                                </div>
                                    }
                                </>
                        }
                    </div>
                }
            </FlexModal>
        );
    }
}

export default StudentResponsePopup;